import * as React from 'react'

import { STUDENT_WAVING_ILLUSTRATION } from '../asset_constants'

const SelectedTourIntroSlide = ({ slideGroupClassName, firstItemCopy=null, secondItemCopy=null, fifthItemCopy=null}) => (
  <section className={`slide ${slideGroupClassName} selected-tour-intro-slide`} key="selected-tour-intro-slide">
    <h1>Here’s what you’ll learn on this tour!</h1>
    <img alt="" src={STUDENT_WAVING_ILLUSTRATION} />
    <ol>
      <li>{firstItemCopy || <span>Discover our five <b>Learning to Write</b> tools to teach students how to write strong, grammatically correct sentences.</span>}</li>
      <li>{secondItemCopy || <span>Learn how to use a <b>Diagnostic</b> to pinpoint where students need to improve.</span>}</li>
      <li><span>Find out how <b>personalized learning plans</b> target student skill gaps.</span></li>
      <li><span>Dive into reporting features to measure skill growth.</span></li>
      {fifthItemCopy && <li>{fifthItemCopy}</li>}
    </ol>
  </section>
)

export default SelectedTourIntroSlide
